import * as Yup from "yup"
import {
	ContractType,
} from "models"
import { DateTime } from "luxon"

export class SendNewProposalForm {
	object: string | null = null
	type: ContractType | null = null
	expireDate: DateTime | null = null
	price: string | null = null
}

const SendNewProposalValidation = {}

export default Yup.object()
	.shape(
		SendNewProposalValidation,
	)
	.required()
